import React, { useEffect } from "react";
import { createPortal } from "react-dom";

interface Props {
  headline: string;
  subheadline?: string;
  glow?: "minimal" | "soft-cosmic";
  onDone: () => void;
  durationMs?: number;
}

/** Full-screen calm transition: language switch and plan entry. */
const EntryMoment: React.FC<Props> = ({ headline, subheadline, glow = "minimal", onDone, durationMs = 2600 }) => {
  useEffect(() => {
    const id = window.setTimeout(onDone, durationMs);
    return () => window.clearTimeout(id);
  }, [onDone, durationMs]);

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex cursor-pointer flex-col items-center justify-center px-6 text-center"
      style={{ background: "var(--astria-bg-app)", animation: "astria-fade 500ms ease-out" }}
      onClick={onDone}
    >
      <style>{`@keyframes astria-fade{from{opacity:0}to{opacity:1}}`}</style>
      <div
        className="mb-8 h-24 w-24 rounded-full"
        style={{
          background: "var(--astria-lang-tint)",
          opacity: glow === "soft-cosmic" ? 0.55 : 0.3,
          filter: "blur(18px)",
          boxShadow: glow === "soft-cosmic" ? "var(--astria-shadow-orb)" : "none",
        }}
      />
      <h2 className="max-w-md text-3xl font-light text-astria-text">{headline}</h2>
      {subheadline && <p className="mt-3 max-w-md text-astria-muted">{subheadline}</p>}
    </div>,
    document.body
  );
};

export default EntryMoment;
